import { __ } from '@wordpress/i18n';
import { Stack, Select, DatePicker } from '@lapilli-ui/components';
import { RawHTML } from '@wordpress/element';

const Block = ( {
	carrierOptions,
	availableDates,
	availableSlots,
	minDate,
	maxDate,
	selectedCarrier,
	selectedDate,
	selectedSlot,
	carrierValidationError,
	dateValidationError,
	slotValidationError,
	onChange,
} ) => {
	const disableDate = ( theDate ) => {
		return (
			availableDates.length > 0 &&
			availableDates.indexOf( theDate.toDateString() ) === -1
		);
	};
	return (
		<Stack
			direction="column"
			className="yith-delivery-date-form"
			spacing={ 1 }
		>
			<Stack
				direction="column"
				className={ carrierValidationError?.message ? 'has-error' : '' }
				sx={ {
					'&.has-error #yith-delivery-date--carrier': {
						borderColor: '#cc1818',
						color: '#cc1818',
					},
				} }
			>
				<label htmlFor="yith-delivery-date--carrier">
					{ __( 'Carrier', 'yith-woocommerce-delivery-date' ) }
				</label>
				<Select
					id="yith-delivery-date--carrier"
					options={ carrierOptions }
					size="xl"
					width="100%"
					value={ '' + selectedCarrier }
					onChange={ ( value ) => onChange( 'carrier', value ) }
				/>
				{ carrierValidationError?.message && (
					<div className="wc-block-components-validation-error">
						<p>{ carrierValidationError.message }</p>
					</div>
				) }
			</Stack>
			{ selectedCarrier !== '-1' && (
				<Stack direction="column">
					<label htmlFor="yith-delivery-date--date">
						{ __(
							'Delivery Date',
							'yith-woocommerce-delivery-date'
						) }
					</label>
					<Stack
						className={
							dateValidationError?.message ? 'has-error' : ''
						}
						sx={ {
							'& .lapilliUI-DatePicker__root > div': {
								width: '100%',
							},
							'&.has-error #yith-delivery-date--date': {
								borderColor: '#cc1818',
								color: '#cc1818',
							},
						} }
					>
						<DatePicker
							id="yith-delivery-date--date"
							size="xl"
							placeholder={ __(
								'Select a date',
								'yith-woocommerce-delivery-date'
							) }
							shouldDisableDate={ disableDate }
							minDate={ minDate }
							maxDate={ maxDate }
							value={ selectedDate }
							onChange={ ( value ) => onChange( 'date', value ) }
						/>
						{ dateValidationError?.message && (
							<div className="wc-block-components-validation-error">
								<p>{ dateValidationError.message }</p>
							</div>
						) }
					</Stack>
				</Stack>
			) }
			{ availableSlots.length > 0 && (
				<Stack
					direction="column"
					className={
						slotValidationError?.message ? 'has-error' : ''
					}
					sx={ {
						'& .lapilliUI-DatePicker__root > div': {
							width: '100%',
						},
						'&.has-error #yith-delivery-date--timeslot': {
							borderColor: '#cc1818',
							color: '#cc1818',
						},
						'& .ywcdd-toggle-slot-content': {
							display: 'inline-block!important',
							marginLeft: '5px',
						},
					} }
				>
					<label htmlFor="yith-delivery-date--timeslot">
						{ __( 'Time Slot', 'yith-woocommerce-delivery-date' ) }
					</label>
					<Select
						id="yith-delivery-date--timeslot"
						size="xl"
						width="100%"
						options={ availableSlots }
						value={ selectedSlot }
						renderOptionContent={ ( option ) => {
							return (
								<div>
									{ option.label }
									<RawHTML>{ option.priceHtml }</RawHTML>
								</div>
							);
						} }
						renderToggleContent={ ( attrs ) => {
							const option =
								attrs.selectedOptions.length > 0
									? attrs.selectedOptions[ 0 ]
									: false;
							return option ? (
								<div style={ { flex: 1 } }>
									{ option.label }
									<RawHTML className="ywcdd-toggle-slot-content">
										{ option.priceHtml }
									</RawHTML>
								</div>
							) : null;
						} }
						onChange={ ( value ) => onChange( 'slot', value ) }
					/>
					{ slotValidationError?.message && (
						<div className="wc-block-components-validation-error">
							<p>{ slotValidationError.message }</p>
						</div>
					) }
				</Stack>
			) }
		</Stack>
	);
};

export default Block;
